import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { mainAxios } from "../app/api";
import service from "../config.json";
import { errorToast, successToast } from "../helpers/toaster";
const {
  getHotelBookings,
  getCarrentBookings,
  getTransferBookings,
  getSignature,
  singleTransferDetail,
  cancelHotelBooking,
  cancelTransferBooking,
  cancelCarrentBooking,
  getMyHotelDetail,
  getFlightBookings,
  cancelFlightBooking,
} = service;

const initialState = {
  hotelBookings: [],
  transferBookings: [],
  carrentBookings: [],
  flightBookings: [],
  singleBookingDetail: {},
  cancelStatus: false,
  signatureData: {},
  singleHotelDetail: {},
};

export const fetchAllMyBookings = createAsyncThunk(
  "user/fetchAllMyBookings",
  async (Authorization) => {
    try {
      const res = await Promise.all([
        mainAxios.get(getHotelBookings, {
          headers: {
            Authorization,
          },
        }),
        mainAxios.get(getCarrentBookings, {
          headers: {
            Authorization,
          },
        }),
        mainAxios.get(getTransferBookings, {
          headers: {
            Authorization,
          },
        }),
        mainAxios.get(getSignature),
        mainAxios.post(
          getFlightBookings,
          {},
          {
            headers: {
              Authorization,
            },
          }
        ),
      ]);

      let obj = {
        hotelBookings: res[0].data.data,
        transferBookings: res[2].data.data,
        carrentBookings: res[1].data.data,
        signatureData: res[3].data.data,
        flightBookings: res[4].data.data,
      };

      return obj;
    } catch (err) {
      const { response } = err;
      return response.data;
    }
  }
);

export const getBookingDetail = createAsyncThunk(
  "transfer/getBookingDetail",
  async (state) => {
    const { ConfirmationNo, Authorization, timestamp, token } = state;
    try {
      const res = await mainAxios.get(
        singleTransferDetail.concat(`/${ConfirmationNo}`),
        {
          headers: {
            Timestamp: timestamp,
            signature: token,
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {}
  }
);

export const hotelBookingCancelAsync = createAsyncThunk(
  "transfer/hotelBookingCancelAsync",
  async (state) => {
    const { Authorization, id } = state;

    try {
      const res = await mainAxios.post(
        cancelHotelBooking,
        { BookingCode: id },
        {
          headers: {
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {}
  }
);
// transferBookingCancelAsync
export const transferBookingCancelAsync = createAsyncThunk(
  "transfer/transferBookingCancelAsync",
  async (state) => {
    try {
      const { timestamp, token, id, Authorization } = state;

      const res = await mainAxios.get(cancelTransferBooking.concat(`/${id}`), {
        headers: {
          Timestamp: timestamp,
          signature: token,
          Authorization,
        },
      });
      return res.data;
    } catch (err) {}
  }
);

// carrentBookingCancelAsync
export const carrentBookingCancelAsync = createAsyncThunk(
  "transfer/carrentBookingCancelAsync",
  async (state) => {
    const { id, Authorization } = state;
    try {
      const res = await mainAxios.get(cancelCarrentBooking.concat(`/${id}`), {
        headers: {
          Authorization,
        },
      });
      return res.data;
    } catch (err) {}
  }
);

export const flightBookingCancelAsync = createAsyncThunk(
  "transfer/flightBookingCancelAsync",
  async (state) => {
    const { id, Authorization } = state;
    console.log({ id });
    try {
      const res = await mainAxios.post(
        cancelFlightBooking,
        { booking_id: id },
        {
          headers: {
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {}
  }
);

export const getMyHotelDetailAsync = createAsyncThunk(
  "hotel/getMyHotelDetailAsync",
  async (state) => {
    const { id, Authorization } = state;

    try {
      const res = await mainAxios.post(
        getMyHotelDetail,
        {
          booking_id: id,
        },
        {
          headers: {
            Authorization,
          },
        }
      );
      return res.data;
    } catch (err) {}
  }
);

export const allBookingSlice = createSlice({
  name: "allBookings",
  initialState,
  reducers: {
    resetCancelStatus: (state) => {
      state.cancelStatus = false;
    },
  },
  extraReducers: {
    [fetchAllMyBookings.pending]: (state) => {
      return { ...state, loading: true };
    },
    [fetchAllMyBookings.fulfilled]: (state, { payload }) => {
      const {
        hotelBookings,
        carrentBookings,
        transferBookings,
        signatureData,
        flightBookings,
      } = payload;
      sessionStorage.setItem("signatureData", JSON.stringify(signatureData));
      return {
        ...state,
        loading: false,
        hotelBookings,
        carrentBookings,
        transferBookings,
        flightBookings,
      };
    },
    [getBookingDetail.fulfilled]: (state, { payload }) => {
      return { ...state, loading: false, singleBookingDetail: payload.data[0] };
    },
    [hotelBookingCancelAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [hotelBookingCancelAsync.fulfilled]: (state, { payload }) => {
      return { ...state, loading: false, cancelStatus: payload.success };
    },
    [transferBookingCancelAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [transferBookingCancelAsync.fulfilled]: (state, { payload }) => {
      return { ...state, loading: false, cancelStatus: payload.success };
    },
    [carrentBookingCancelAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [carrentBookingCancelAsync.fulfilled]: (state, { payload }) => {
      return { ...state, loading: false, cancelStatus: payload.success };
    },
    [flightBookingCancelAsync.pending]: (state) => {
      return { ...state, loading: true };
    },
    [flightBookingCancelAsync.fulfilled]: (state, { payload }) => {
      if (payload.success) {
        successToast("Your cancellation process is being initaited");
        return { ...state, loading: false, cancelStatus: payload.success };
      } else {
        errorToast("something went wrong please try again later ");
      }
    },
    [getMyHotelDetailAsync.fulfilled]: (state, { payload }) => {
      return { ...state, loading: false, singleHotelDetail: payload?.data };
    },
  },
});

export const getTripLoading = (state) => {
  return state.allBookings.loading;
};

export const hotelBookingList = (state) => {
  return state.allBookings.hotelBookings;
};

export const transferBookingList = (state) => {
  return state.allBookings.transferBookings;
};

export const carrentBookingList = (state) => {
  return state.allBookings.carrentBookings;
};

export const flightBookingList = (state) => {
  return state.allBookings.flightBookings;
};

export const getSingleTransferDetails = (state) => {
  return state.allBookings.singleBookingDetail;
};

export const getCancelStatus = (state) => {
  return state.allBookings.cancelStatus;
};

// Action creators are generated for each case reducer function
export const { resetCancelStatus } = allBookingSlice.actions;

export default allBookingSlice.reducer;
